import { useRef, useState } from 'react';

import type { ModuleOrPlanActionOrgUnit } from 'src/types/orgUnit';
import type {
  NodeObject,
  OrgTreeState,
  OrgUnitMap,
} from 'src/components/common/OrgTree/types';

/**
 * This hook returns the org tree state which is used by the org tree for updating the tree. The reason this is a
 * separate hook that creates the states that will then have to be passed to the OrgTree-Component is mostly due to
 * legacy behavior.
 * Some components need to access the org tree state but the state has to be independent between the modules and in
 * some cases even independent between multiple org trees within a module, e.g. OrgTreeModal.
 */
export const useOrgTreeState = (): OrgTreeState => {
  const [latestSelectedOrgUnit, setLatestSelectedOrgUnit] =
    useState<ModuleOrPlanActionOrgUnit>();
  const [selectedOrgUnits, setSelectedOrgUnits] = useState<
    ModuleOrPlanActionOrgUnit[]
  >([]);
  const [nodes, setNodes] = useState<NodeObject[]>([]);
  const orgUnitMapRef = useRef({});
  const setOrgUnitMap = (orgUnitMap: OrgUnitMap) =>
    (orgUnitMapRef.current = orgUnitMap);

  return {
    latestSelectedOrgUnit,
    setLatestSelectedOrgUnit,
    selectedOrgUnits,
    setSelectedOrgUnits,
    orgUnitMap: orgUnitMapRef.current,
    setOrgUnitMap,
    nodes,
    setNodes,
  };
};

export default useOrgTreeState;
